import { ListItemButton, Grid, Typography } from '@mui/material';
import { UnderlyingsSearchResponse } from '@oai-frontend-monorepo/api';
import { memo } from 'react';

interface Props {
  result?: UnderlyingsSearchResponse;
  onSelect?: (symbol: string) => void;
}

const SearchResultItem = ({ result, onSelect }: Props) => {
  const handleSelect = () => {
    if (!result) {
      throw new Error('Result is undefined');
    }

    onSelect?.(result.symbol);
  };

  if (!result?.symbol) return null;

  return (
    <ListItemButton key={result.symbol} divider onClick={handleSelect}>
      <Grid alignItems={'center'} my={1.5} container>
        <Grid item xs={3}>
          <Typography fontWeight="bold" variant="h5">
            {result.symbol}
          </Typography>
        </Grid>

        <Grid item xs={9}>
          <Typography variant="body1" color="grey" noWrap>
            {result.name}
          </Typography>
        </Grid>
      </Grid>
    </ListItemButton>
  );
};

export default memo(SearchResultItem);
